Greenmile.Gallery = Greenmile.Gallery || {};

Greenmile.Gallery.Picture = (function () {

    pictureGallery.prototype = new Monet.GenericModal();

    function pictureGallery () {

        this.target = null;
        this.currentAlbumId = null;
        this.afterClose = null;

        Monet.Session.PhotoAlbum = Monet.Session.PhotoAlbum || {};
        Monet.Session.PhotoAlbum.albumsList = Monet.Session.PhotoAlbum.albumsList || [];

        const getLiveAlbumId = () => {
            const albums = Monet.Session.PhotoAlbum.albumsList || [];
            let liveAlbumId = null;
            const userId = Monet.Session.User.id;

            albums.map(item => {
                if(item.photoAlbum.key && item.photoAlbum.key.includes('LIVE') && item.photoAlbum.user && item.photoAlbum.user.id === userId){
                    liveAlbumId = item.photoAlbum.id;
                }
            });

            return liveAlbumId;
        };

        const getBlockSelector = (selector) => {

            let blockSelector = "";

            if (selector.indexOf('RouteSummary') !== -1) {
                blockSelector = "#allContent";
            } else if (selector.indexOf('PhotoAlbum') !== -1) {
                blockSelector = "#photoAlbumConteiner";
            } else if (selector.indexOf('routeMaps') !== -1 || selector.indexOf('RouteDetails') !== -1) {
                blockSelector = "#" + selector + " .containerRouteDetail";
            }

            return blockSelector;
        };

        const showLoading = () => {
            const containerAllPictures = document.querySelector(this.obj.selector + ' #container_all_pictures');
            const loadingElement = `
                <div class="loadingPhotos">
                    <div class="loadingSpinner"></div>
                    ${Monet.I18n.getResourcesByKey("galleryPopup.loading")}
                </div>
            `;
            if (containerAllPictures) {
                containerAllPictures.innerHTML = loadingElement;
            }
            return loadingElement;
        };

        const convertImageToBinary = (fileBase64) => {
            if (!fileBase64) {
              return new Uint8Array(new ArrayBuffer(0));
            }
            const BASE64_MARKER = ';base64,';
            const base64Index = fileBase64.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
            const base64 = fileBase64.substring(base64Index);
            const raw = atob(base64);
            const rawLength = raw.length;
            const array = new Uint8Array(new ArrayBuffer(rawLength));
            for (let i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
            }
            return array;
        };

        const isTabValid = () => {
            const currentTab = this.target ? this.target.getAttribute("tabname") : Monet.Utils.GetTabName();
            return /^(RouteDetails_\d+|RouteSummary)/.test(currentTab);
        };

        const hasDeletePermission = () => {
            const permissions = Monet.Session.Security.permissions;
            const hasPermission = permissions && permissions.some(e => e.key === "PHOTO_REMOVE");
            const canDelete = hasPermission;

            if (!canDelete) {
                const deleteButton = document.querySelector('.viewer-delete');
                if (deleteButton) {
                    deleteButton.classList.add('disabled');
                }
            }

            return canDelete;
        };

        const removeNode = (selector) => {
            const container = document.querySelector(`${this.obj.selector} ${selector}`);
            if (container) {
                container.parentNode.removeChild(container);
            }
        };

        const showCurrentAlbumArrow = (albumId) => {
            this.currentAlbumId = albumId;
            const albumsThumbs = document.querySelectorAll(this.obj.selector + ' .containerThumb');
            const currentAlbumThumb = document.querySelector(this.obj.selector + ' .containerThumb#album_' + albumId);
            if (albumsThumbs && currentAlbumThumb) {
                for (let i=0; i < albumsThumbs.length; i++) {
                    albumsThumbs[i].classList.remove('currentAlbum');
                }
                currentAlbumThumb.classList.add('currentAlbum');
                if (Greenmile.Platform.browser.name !== 'MSIE') {
                    currentAlbumThumb.scrollIntoView({ behavior: "smooth", block: "nearest" });
                }
            }
        };

        this.loadAlbumsList = (options, successCallback, errorCallback) => {

            options = options || {};

            let body = '';

            const { id } = this.target;

            if (this.target.getAttribute('entity') === 'stop') {
                body = '{ "stops" : [{ "id" : ' + id + '}] }';
            } else if (this.target.getAttribute('entity') === 'route') {
                body = '{ "routes" : [{ "id" : ' + id + '}] }';
            }

            showLoading();

            const ajax = new Monet.Ajax();
            ajax.url = 'PhotoAlbum/Find';
            ajax.method = 'POST';
            ajax.data = body;
            ajax.success = (albumsList) => {
                if (successCallback) {
                    successCallback(albumsList, options);
                } else {
                    this.generateModalContent(albumsList, options);
                }
            };
            ajax.error = (xhr) => {
                if (errorCallback) {
                    errorCallback(xhr)
                } else {
                    this.errorCallback(xhr);
                }
            };
            ajax.send();
        }

        this.deleteAlbum = (albumId) => {
            const ajax = new Monet.Ajax();
            ajax.url = `PhotoAlbum/${albumId}`;
            ajax.method = 'DELETE';
            ajax.success = () => {
                this.loadAlbumsList();
            };
            ajax.error = () => {
                showError('galleryPopup.deleteError');
            };
            ajax.send();
        };

        this.deleteImage = (viewer) => {
            const { photoId, albumId } = viewer.images[viewer.index];

            if (hasDeletePermission()) {
                viewer.hide();
                showLoading();

                const ajax = new Monet.Ajax();
                ajax.url = `Photo/${photoId}`;
                ajax.method = 'DELETE';
                ajax.success = () => {
                    if (Monet.Session.PhotoAlbum.albumsDetails && Monet.Session.PhotoAlbum.albumsDetails[albumId]) {
                        delete Monet.Session.PhotoAlbum.albumsDetails[albumId];
                    }
                    if(!this.currentAlbumId) {
                        const albumLength = viewer.images.length;
                        if (albumLength > 1) {
                            this.loadAlbumsList({ albumId });
                        } else {
                            this.loadAlbumsList();
                        }
                    } else {
                        this.requestAlbumPictures(this.currentAlbumId, false);
                    }
                };
                ajax.error = () => {
                    showError('galleryPopup.deleteError');
                };
                ajax.send();
            }
        };

        this.uploadPhoto = (image, extensionImage) => {
            const liveAlbumExists = getLiveAlbumId() ? true : false;
            const isStop = this.target.getAttribute('entity') === 'stop';
            const albumId = parseInt(this.target.getAttribute('id'));
            const routeId = isStop ? this.target.getAttribute('routeId') : albumId;
            const albumKey = `LIVE_${albumId}`;
            const now = new Date().getTime();

            const fileName = isStop
              ? `${albumKey}_${routeId}_${albumId}_${now}.${extensionImage}`
              : `${albumKey}_${routeId}_${now}.${extensionImage}`;

            const formData = new FormData();
            const uploadButton = document.querySelector(this.obj.selector + ' label.uploadButton');

            uploadButton.innerText = Monet.I18n.getResourcesByKey('galleryPopup.uploading');
            uploadButton.classList.add('loading');

            const jsonData = {
                pictureInformation: {
                    photoAlbum: {
                        key: albumKey,
                        user: {
                            id: Monet.Session.User.id
                        },
                        route: {
                            id: routeId
                        }
                    }
                }
            };

            if(!liveAlbumExists) {
                jsonData.pictureInformation.photoAlbum.description = "LIVE";
                jsonData.pictureInformation.photoAlbum.time = new Date().toJSON();
            }

            if (isStop) {
                jsonData.pictureInformation.photoAlbum.stop = {
                    id: albumId,
                    key: this.target.getAttribute('key'),
                };
            }

            Object.keys(jsonData).forEach((prop) => {
                formData.append(prop, new Blob([JSON.stringify(jsonData[prop])], { type: 'application/json' }));
            });

            formData.append('file', new Blob([convertImageToBinary(image)]), fileName)

            const url = isStop ? `Photo/Stop/WithAlbum` : `Photo/Route/WithAlbum`;
            const ajax = new Monet.Ajax({ contentType: 'multipart/form-data' });
            ajax.url = url;
            ajax.method = 'POST';
            ajax.data = formData;
            ajax.success = () => {
                this.loadAlbumsList({ shouldGetLiveAlbum: true });
            }
            ajax.error = () => {
                showError('galleryPopup.uploadError');
            }
            ajax.send();
        };

        const showError = (errorMessage) => {
            const container = document.querySelector(this.obj.selector + ' #container_all_pictures');
            const errorDescription = container.querySelector('.errorContainer .errorDescription');

            if (!errorDescription) {
                const errorDescription = document.createElement('span');
                errorDescription.className = 'errorDescription';
                errorDescription.innerText = Monet.I18n.getResourcesByKey(errorMessage);

                const errorIcon = document.createElement('i');
                errorIcon.className = 'fa fa-times-circle';

                const errorContainer = document.createElement('div');
                errorContainer.className = 'errorContainer';
                errorContainer.appendChild(errorIcon);
                errorContainer.appendChild(errorDescription);
                container.insertBefore(errorContainer, container.firstChild);
            } else {
                errorDescription.innerText = Monet.I18n.getResourcesByKey(errorMessage);
            }
        };

        this.processFile = (file, data) => {
            let errorMessage = null;
            const fileName = file.name;
            const extensionImage = String(fileName).split('.').pop();
            const isValid = () => {
                // Validate file size
                const maxFileSize = 3145728;
                if (data.lengthComputable && data.total > maxFileSize) {
                    errorMessage = "galleryPopup.fileSizeError";
                }
                // Validate file format
                if (!file.name.match(new RegExp("^.*\.(jpg|jpeg|JPG|JPEG|png|PNG)"))) {
                    errorMessage = "galleryPopup.fileFormatError";
                }
                return !errorMessage;
            };

            if (isValid()) {
                const base64Image = data.target.result;
                this.uploadPhoto(base64Image, extensionImage);
            } else {
                const fileInputElement = document.querySelector(this.obj.selector + " #fileInputId");
                if (fileInputElement) {
                    fileInputElement.value = '';
                }
                showError(errorMessage);
            }
        };

        this.setupViewer = (picturesGrid) => {
            const showDelete = hasDeletePermission();
            const viewer = new Viewer(picturesGrid, {
                view: (event) => {
                    this.requestLargeImage(event);
                },
                toolbar: {
                    play: false,
                    oneToOne: false,
                    flipHorizontal: false,
                    flipVertical: false,
                    reset: { show: true, size: 'large' },
                    rotateLeft: { show: true, size: 'large' },
                    rotateRight: { show: true, size: 'large' },
                    prev: { show: true, size: 'large' },
                    next: { show: true, size: 'large' },
                    zoomOut: { show: true, size: 'large' },
                    zoomIn: { show: true, size: 'large' },
                    delete: { show: showDelete, size: 'large',
                        click: () => {
                            this.deleteImage(viewer);
                        }
                    },
                    deleteDisabled: { show: !showDelete, size: 'large'}
                },
                title: () => viewer.images[viewer.index].photoComment
            });
            this.viewer = viewer;
        };

        this.renderAlbumGallery = (album) => {

            album = album || { photos: [] };

            const headerContainer = document.createElement("div");
            const titleWrapper = document.createElement("div");
            const spanTitle = document.createElement('span');
            const albumCategory = document.createElement("div");
            const inputTitle = document.createElement('input');
            const untitled = Monet.I18n.getResourcesByKey("PhotoAlbum.untitled.album");
            const formError = document.createElement('div');
            let titleText = album.description || untitled

            inputTitle.type = "text";
            inputTitle.value = titleText;
            inputTitle.classList.add("inputTitle");
            spanTitle.innerText = titleText;
            formError.classList.add("formError");
            formError.innerText = Monet.I18n.getResourcesByKey("general.form.unknownError");
            formError.style.display = "none";
            headerContainer.classList.add("albumTitleContainer");
            titleWrapper.classList.add("titleWrapper");
            titleWrapper.appendChild(spanTitle);

            titleListeners(titleWrapper, inputTitle, formError, titleText, spanTitle, album.id, untitled);

            albumCategory.className = "albumCategory";
            const resourceCategory = Monet.I18n.getResourcesByKey(album.lineItem ? "LineItem" : album.order ? "Order" : album.stop ? "Stop" : "Route");
            const creationDate = Monet.Format.Date.formatToLocale(album.creationDate);;
            albumCategory.innerHTML = Monet.I18n.translateResources('Gallery.Picture.AlbumCategory', { category: resourceCategory, date:creationDate });

            headerContainer.appendChild(titleWrapper);
            headerContainer.appendChild(formError)
            headerContainer.appendChild(albumCategory);

            const ownerContainer = document.createElement("div");
            ownerContainer.className = "albumOwner";
            const textOwner = document.createTextNode(`${Monet.I18n.getResourcesByKey("PhotoAlbum.createdBy")}: ${album.user.name}`);
            ownerContainer.appendChild(textOwner);

            // Render gallery grid
            const picturesGrid = document.createElement("div");
            picturesGrid.className = 'picturesGrid';

            let galleryContainer;

            if (album.photos) {
                album.photos.forEach((photo) => {
                    const largeImage = Monet.Session.PhotoAlbum.largeImage && Monet.Session.PhotoAlbum.largeImage[photo.id];
                    const thumbnail = document.createElement("div");
                    const img = document.createElement("img");

                    thumbnail.className = "medium_thumb photo_" + photo.id;
                    img.albumId = album.id;
                    img.photoId = photo.id;
                    img.photoComment = photo.photoComment || "";
                    img.src = "data:image/png;base64," + (largeImage ? largeImage.base64Image : photo.base64Thumbnail);

                    thumbnail.appendChild(img);
                    picturesGrid.appendChild(thumbnail);
                });

                this.setupViewer(picturesGrid);

                galleryContainer = document.createElement('div');
                galleryContainer.className = 'galleryContainer';
                galleryContainer.appendChild(headerContainer);
                galleryContainer.appendChild(picturesGrid);
            }

            const containerAllPictures = document.querySelector(this.obj.selector + ' #container_all_pictures');
            if (containerAllPictures) {
                while (containerAllPictures.firstChild) {
                    containerAllPictures.removeChild(containerAllPictures.firstChild);
                }
                if (galleryContainer) {
                    containerAllPictures.appendChild(galleryContainer);
                } else {
                    containerAllPictures.appendChild(showEmptyAlbum());
                }
                containerAllPictures.appendChild(ownerContainer);
            }
        };

        const titleListeners = (titleWrapper, inputTitle, formError, titleText, spanTitle, albumId, untitled) => {

            const listernerInput = () => updateDescription();

            inputTitle.addEventListener("focusout", listernerInput);

            spanTitle.addEventListener('click', () => inputMode());

            inputTitle.addEventListener("keydown", (e) => {
                formError.style.display = "none";
                const key = e.which || e.keyCode;

                if (key === 13) { // 13 is enter
                    inputTitle.removeEventListener("focusout", listernerInput);
                    updateDescription();
                } else if(key === 27) { // 27 is esc
                    inputTitle.removeEventListener("focusout", listernerInput);
                    labelMode();
                }
            });

            const updateDescription = () => {
                const description = inputTitle.value;
                const ajax = new Monet.Ajax();

                if(titleText !== description) {
                    inputTitle.removeEventListener("focusout", listernerInput);
                    inputTitle.classList.add("loading");

                    ajax.url = `PhotoAlbum/UpdateDescription`;
                    ajax.method = 'post';
                    ajax.data = {
                        id: albumId,
                        description: description
                    };

                    ajax.success = () => {
                        titleText = description || untitled;
                        spanTitle.innerText = titleText;
                        inputTitle.classList.remove("loading");
                        updateAlbumThumb();
                        labelMode();
                    };

                    ajax.error = () => {
                        inputTitle.classList.remove("loading");
                        inputTitle.addEventListener("focusout", listernerInput);
                        formError.style.display = "block";
                    };

                    ajax.send();

                } else {
                    labelMode();
                }
            }

            const inputMode = () => {
                titleWrapper.removeChild(spanTitle);
                titleWrapper.appendChild(inputTitle);
                inputTitle.value = titleText;
                inputTitle.focus();
            }

            const labelMode = () => {
                titleWrapper.removeChild(inputTitle)
                titleWrapper.appendChild(spanTitle);
                inputTitle.addEventListener("focusout", listernerInput);
                formError.style.display = "none";
            }

            const updateAlbumThumb = () => {
                const albumThumb = document.querySelector(this.obj.selector + " #thumbAlbumTitle_" + albumId);
                if(albumThumb) albumThumb.innerText = titleText;
            }
        }

        const getUploadButtonTemplate = () => {
            return (isTabValid() && `
                <label type="button" class="uploadButton">
                    ${Monet.I18n.getResourcesByKey("galleryPopup.uploadButton")}
                    <input type="file" class="fileInput" id="fileInputId" accept=".jpg, .jpeg, .png" multiple/>
                </label>
            `) || "";
        };

        const getDeleteAlbumButtonTemplate = () => {
            return (isTabValid() && `
                <div class="deleteAlbumButton">
                    ${Monet.I18n.getResourcesByKey("galleryPopup.deleteAlbumButton")}
                </div>
            `) || "";
        };

        const getNoPhotosTemplate = (options) => {
            const showDeleteAlbumButton = options && options.showDeleteAlbumButton;
            return `
                <div class="noPhotos">
                    <div class="gallery-not-found-img"></div>
                    <div class="text">${Monet.I18n.getResourcesByKey("galleryPopup.noPhotos")}</div>
                    ${ showDeleteAlbumButton ? getDeleteAlbumButtonTemplate() : getUploadButtonTemplate()}
                </div>
            `;
        };

        const showEmptyAlbum = () => {
            const emptyAlbumContainer = document.createElement('div');
            emptyAlbumContainer.innerHTML = getNoPhotosTemplate({ showDeleteAlbumButton: true });
            const deleteAlbumHandler = () => {
                this.deleteAlbum(this.currentAlbumId);
            };
            emptyAlbumContainer.querySelector('.deleteAlbumButton').addEventListener('click', deleteAlbumHandler);
            return emptyAlbumContainer;
        };

        this.buildTemplate = (albums) => {
            const showAlbumList = albums.length > 0 && isTabValid();

            let content = '<div class="generalContainer">';
            content += `<div class='galleryTitleContainer'>${Monet.I18n.getResourcesByKey("galleryPopup.title")}</div>`
            content += '<div class="photosContainer">';

            // Albums thumbs Container

            if (showAlbumList) {

                const shouldAnimate = (!Monet.Session.PhotoAlbum.albumsDetails && "shouldAnimate") || "";

                content += `<div class="albumsWrapper ${shouldAnimate}"><div class="albumsContainer">`;

                for (let i = 0; i < albums.length; i++) {
                    let thumbAlbumTitle = albums[i].photoAlbum.description || Monet.I18n.getResourcesByKey('PhotoAlbum.untitled.album');

                    content += '<div class="containerThumb" id="album_' + albums[i].photoAlbum.id + '">';
                    if (typeof albums[i].photoAlbum.photos !== 'undefined') {
                        for (let j = 0; j < albums[i].photoAlbum.photos.length; j++) {
                            if (j < 3) {
                                content += `
                                    <div class="mini_thumb">
                                        <img src="data:image/png;base64,${albums[i].photoAlbum.photos[j].base64Thumbnail}">
                                    </div>
                                `;
                            }
                            else if(j === 3) {
                                const photosOverlay = (albums[i].totalPhotos > 4) ? `<div><span>+${albums[i].totalPhotos - j - 1}</span></div>` : '';

                                content += `
                                    <div class="mini_thumb">
                                        <img src="data:image/png;base64,${albums[i].photoAlbum.photos[j].base64Thumbnail}">
                                        ${photosOverlay}
                                    </div>
                                `;
                            }
                        }
                    }
                    content += `</div><span id="thumbAlbumTitle_${albums[i].photoAlbum.id}" class="thumbAlbumTitle">${thumbAlbumTitle}</span>`;
                }

                if (this.target) {
                    content += getUploadButtonTemplate();
                }

                content += '</div></div>';

            }

            // Photos gallery container

            const initialContent = albums.length === 0 ? getNoPhotosTemplate() : showLoading();

            content += `
                <div class="picture container_medium_thumb" id="container_all_pictures">
                    ${initialContent}
                </div>
            `;
            content += '</div>';

            return content;

        };

        this.generateModalContent = (albums, options) => {

            const { albumId, shouldGetLiveAlbum } = options;

            Monet.Session.PhotoAlbum.albumsList = albums;

            removeNode('.galleryPopup');
            const galleryPopup = document.createElement("div");
            galleryPopup.setAttribute("class", "galleryPopup");
            galleryPopup.innerHTML = this.buildTemplate(albums);

            if ($(".popupFormContainer .popup_signature").length > 0) {
                $(".popupFormContainer .popup_signature").remove();
            }

            const popupFormContainer = document.querySelector(this.obj.selector + ' .popupFormContainer');
            if (popupFormContainer) {
                popupFormContainer.appendChild(galleryPopup);
            }

            this.addEventListeners();

            const firstAlbumId = albums.length > 0 && (albums[0].id || albums[0].photoAlbum.id);
            const initialAlbumId = shouldGetLiveAlbum ? getLiveAlbumId() : (albumId || firstAlbumId);
            if (initialAlbumId) {
                this.requestAlbumPictures(initialAlbumId, true);
            }
        };

        this.requestAlbumPictures = (albumId, forceUpdate) => {

            showCurrentAlbumArrow(albumId);

            Monet.Session.PhotoAlbum.albumsDetails = Monet.Session.PhotoAlbum.albumsDetails || {};

            if (Monet.Session.PhotoAlbum.albumsDetails[albumId] && !forceUpdate) {
                this.renderAlbumGallery(Monet.Session.PhotoAlbum.albumsDetails[albumId]);
            } else {
                showLoading();
                const ajax = new Monet.Ajax();
                ajax.url = 'PhotoAlbum/' + albumId + '/ListPhotos?thumbnailSize=SMALL';
                ajax.method = 'GET';

                ajax.success = (albumImages) => {
                    if (Monet.Session.PhotoAlbum.albumsDetails) {
                        Monet.Session.PhotoAlbum.albumsDetails[albumId] = albumImages;
                    }
                    if (albumId === this.currentAlbumId) {
                        this.renderAlbumGallery(albumImages);
                    }
                };

                ajax.error = (xhr) => {
                    Monet.Configurations.errorNotification(null, xhr);
                    removeNode('#container_all_pictures');
                    this.errorCallback(xhr);
                };

                ajax.send();
            }

        };

        this.setLargeImage = (photoId, originalImage, canvas, index) => {
            canvas.classList.remove('viewer-loading');
            const data = Monet.Session.PhotoAlbum.largeImage[photoId];
            const base64String = data ? "data:image/png;base64," + data.base64Image: "";
            if (originalImage.src !== base64String) {
                originalImage.src = base64String;
                this.viewer.update();
                this.viewer.view(index);
            }
        };

        this.requestLargeImage = (event) => {

            const { index, originalImage, originalImage: { photoId } } = event.detail;
            const canvas = event.srcElement.viewer.canvas;

            canvas.classList.add('viewer-loading');

            Monet.Session.PhotoAlbum = Monet.Session.PhotoAlbum || {};
            Monet.Session.PhotoAlbum.largeImage = Monet.Session.PhotoAlbum.largeImage || [];

            const largeImage = Monet.Session.PhotoAlbum.largeImage[photoId];

            if (typeof largeImage === "undefined") {
                event.preventDefault();
                const ajax = new Monet.Ajax();
                ajax.url = 'Photo/' + photoId + '/Image';
                ajax.type = 'GET';
                ajax.success = (largeImageData) => {
                    Monet.Session.PhotoAlbum.largeImage[photoId] = largeImageData;
                    this.setLargeImage(photoId, originalImage, canvas, index);
                };
                ajax.error = (xhr) => {
                    this.errorCallback(xhr);
                }
                ajax.send();
            } else {
                this.setLargeImage(photoId, originalImage, canvas, index);
            }

        };

        this.addEventListeners = () => {

            // File input
            const fileInputElement = document.querySelector(this.obj.selector + " #fileInputId");
            if (fileInputElement) {
                fileInputElement.addEventListener("change", (e) => {
                    const files = e.target.files;
                    Array.from(files).map(file => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = (data) => this.processFile(file, data);
                    });
                }, false);
            }

            // Albums thumbs
            const albums = Monet.Session.PhotoAlbum.albumsList;
            albums.forEach(album => {
                const albumId = album.id || album.photoAlbum.id;
                const albumThumb = document.querySelector(this.obj.selector + " #album_" + albumId);
                if (albumThumb) {
                    const loadAlbumGallery = () => {
                        this.requestAlbumPictures(albumId);
                    };

                    albumThumb.removeEventListener("click", loadAlbumGallery);
                    albumThumb.addEventListener("click", loadAlbumGallery);
                }
            });

            // Popup close button
            const closeModalButton = document.querySelector(this.obj.selector + " .closeModalWindow");
            if (closeModalButton) {
                const closingActions = () => {
                    Monet.Session.PhotoAlbum.albumsList = null;
                    Monet.Session.PhotoAlbum.albumsDetails = null;
                    this.viewer && this.viewer.destroy();
                    if ($(".signaturePopupContainer").length > 0) {
                        $(".signaturePopupContainer").remove();
                    }

                    this.afterClose?.();
                };

                closeModalButton.removeEventListener("click", closingActions);
                closeModalButton.addEventListener("click", closingActions);
            }

        };

        this.addGenericListener = (target, event) => {
            event && event.stopPropagation(); //prevents panel builder card flipping

            this.target = target;

            const selector = target.getAttribute("tabname");
            const blockSelector = getBlockSelector(selector);

            const modalObj = {
                "selector": `#${selector}`,
                "scopeBlock": blockSelector,
                "width": 765,
                "height": 500
            };

            const removeMenu = () => {
                removeNode('.MonetUIFloatMenu');
            };

            this.show(modalObj);

            this.iconLoading();

            const successCallback = (albumsList, options) => {
                removeNode('.loadingPopupFormContainer');
                removeMenu();
                this.generateModalContent(albumsList, options);
            };

            const errorCallback = (xhr) => {
                removeNode('.loadingPopupFormContainer');
                removeMenu();
                this.errorCallback(xhr);
            };

            this.loadAlbumsList({}, successCallback, errorCallback);

        };

        this.closeModal = (selector) => {
            const closeButton = document.querySelector(`#${selector} .popupFormContainer`);
            const modalObj = document.querySelector(`#${selector} .closeModalWindow`);

            modalObj && modalObj.remove();
            closeButton && closeButton.remove();

            Monet.Session.PhotoAlbum.albumsList = null;
            Monet.Session.PhotoAlbum.albumsDetails = null;

            this.viewer && this.viewer.destroy();

            if ($(`#${selector} .signaturePopupContainer`).length > 0) {
                $(`#${selector} .signaturePopupContainer`).remove();
            }
        };

        this.createAllStructure = function () {
            return function () {
            };
        }(this);

    }

    return pictureGallery;

})();
